import { createFileRoute } from '@tanstack/react-router';

import { PipeRatePredictionsListPage } from '@/features/pipe-predictions/PipeRatePredictionsListPage';

export const Route = createFileRoute('/admin/_app/pipe-rate-predictions/')({
  component: PipeRatePredictionsListPage,
});
